import type { RenderedBlock } from "@/blocks/blocks";
import { BlockTree } from "@/blocks/block-tree";
import type {
  FeatureBlock,
  PointBlock,
  RemoteGeoJSONBlock,
} from "@/blocks/geojson.blocks";
import Point from "./point";
import Pending from "./pending";
import Feature from "./feature";
import type { RouteBlock } from "@/blocks/routes.blocks";
import Route from "./route";
import RemoteGeoJson from "./remote-geojson";

export default function Block({
  block,
  tree,
}: {
  block: RenderedBlock;
  tree: BlockTree;
}) {
  const { type } = block;

  switch (type) {
    case "point":
      return <Point block={block as PointBlock} />;
    case "feature":
      return <Feature block={block as FeatureBlock} tree={tree} />;
    case "route":
      return <Route block={block as RouteBlock} tree={tree} />;
    case "pending":
      return <Pending />;
    case "remotegeojson":
      return <RemoteGeoJson block={block as RemoteGeoJSONBlock} />;

    default:
      return <div>?</div>;
  }
}
